import { forwardRef } from "react";
import type { IDateRangePickerButton } from "./../../../types/date_range_picker/button";
import { Calendar, CircleXmark } from "../../../assets/Icons";
import styles from "./date-range-picker-button.module.scss";

export const DateRangePickerButton = forwardRef<HTMLDivElement, IDateRangePickerButton>((
  {
    id,
    label,
    placeholder,
    text,
    disabled,
    onClickHandler,
    onClearDateHandler,
    iconOnly,
    isMobile
  },
  ref
) => {

  return (
    <div
      id={id}
      ref={ref}
      className={styles["date-range-picker"]}
    >

      {
        label && !iconOnly &&
        <div className={styles["date-range-picker__label"]}>
          {label}
        </div>
      }

      <button
        className={styles["date-range-picker__button"]}
        {...(iconOnly ? { "data-drp-btn-icon-only": true } : {})}
        {...(isMobile ? { "data-drp-btn-is-mobile": true } : {})}
        {...(
          text ?
            { "data-drp-btn-text": text }
            :
            (
              placeholder ?
                { "data-drp-btn-placeholder": placeholder }
                :
                {}
            )
        )}
        disabled={disabled}
        onClick={onClickHandler}
      >

        <div className={styles["date-range-picker__button__calendar-icon"]}>
          {Calendar}
        </div>

        {!iconOnly && (text || placeholder)}

        {
          onClearDateHandler && !iconOnly &&
          <div
            className={styles["date-range-picker__button__clear-icon"]}
            onClick={onClearDateHandler}
          >
            {CircleXmark}
          </div>
        }

      </button>
    </div>
  )
});